// extracted by mini-css-extract-plugin
export default {"cardes_div":"cards_cardes_div__aTP7U","a":"cards_a__Ilkm+","img":"cards_img__B9AUQ","h2":"cards_h2__7lW3S","p":"cards_p__fIkwn","elements":"cards_elements__XEBmq"};